<template lang="pug">
  .TheFooterBottomContent.footer-bottom-content
    p.footer-bottom-content__text Securities are offered through AcreTrader Financial, LLC, a registered broker-dealer, a member of&nbsp;
      a.link-4.small-link(
        href="https://www.finra.org/#/"
        target="_blank"
        rel="noreferrer"
      ) FINRA
      | &nbsp;|&nbsp;
      a.link-4.small-link(
        href="https://www.sipc.org/"
        target="_blank"
        rel="noreferrer"
      ) SIPC
      | . Information on all FINRA registered broker dealers can be found on FINRA’s&nbsp;
      a.link-4.small-link(
        href="https://brokercheck.finra.org/"
        target="_blank"
        rel="noreferrer"
      ) BrokerCheck
      | .
    p.footer-bottom-content__text
      |  Past performance is no guarantee of future results.
      |  Alternative investments involve a high degree of risk and are speculative, and you should not
      |  invest unless you are able to sustain the risk of loss of your entire investment.
    p.footer-bottom-content__text  Farmland investments are also subject to additional risks including volatility in land
      |  and/or commodity prices, weather events or disease that could damage crops and many other
      |  operational factors. The PPM for each Offering includes more complete information on
      |  risks associated with each investment.
    p.footer-bottom-content__text
      |  Private placements are considered illiquid investments and not a short-term investment.
      |  Private placements are offered by Private Placement Memorandum only and subject to certain
      |  limitations and restrictions and for accredited investors and not suitable for all investors.
      |  Offerings represent interest in newly formed entities. Private funds are not registered under
      |  the Securities Act or under any state securities laws or the securities laws of any other jurisdiction.
      |  Distributions are not guaranteed. There is no assurance any investment will achieve its objectives.
    p.footer-bottom-content__text
      |  For more information read our&nbsp;
      a.link-4.small-link(
        href="/company/terms#general-disclosures"
      ) General Disclosures
      |  and&nbsp;
      a.link-4.small-link(
        href="/company/terms#securities-matters"
      ) Securities Matters
      |  and for a more complete description of these investment risks click&nbsp;
      a.link-4.small-link(
        :href="require('doc/Acretrader-General-Risk-Statement.pdf')",
        target="_blank"
      ) Acretrader General Risk Document
      | .
    p.footer-bottom-content__text.is--last Content provided is not intended to be a recommendation or
      |  investment advice and is not an offer
      |  to buy or sell any specific security. Information provided does not take into account an investor’s
      |  specific objectives or risk profile. Investment decisions should be made based on your objectives
      |  and circumstances and in consultation with your own advisors. AcreTrader Financial does not provide
      |  tax, legal or accounting advice. Please consult with and rely on a qualified professional.
</template>

<script>

export default {
  name: 'TheFooterBottomContent',
};
</script>
<style lang="sass" scoped>
@import '~Styles/_variables'
.footer-bottom-content
  &__text
    color: $alabaster
    +font(400)
    font-size: 12px
    line-height: 16.8px
    &.is--last
      margin-bottom: 0
</style>
